import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Cookie from 'js-cookie';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Config } from './../config/config';
import LZString from 'lz-string';

class Menu extends Component {
  constructor(props) {
    super(props);

    const config = JSON.parse(Config);

    let stores = JSON.parse(localStorage.getItem('storeData')).sort((a, b) =>
      a.storeName > b.storeName ? 1 : -1
    );
    let warehouses = JSON.parse(
      localStorage.getItem('warehouseData')
    ).sort((a, b) => (a.storeName > b.storeName ? 1 : -1));

    // stores = JSON.parse(Cookie.get('stores'));

    // warehouses = JSON.parse(Cookie.get('warehouses'));

    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let currentMonth = new Date().getMonth() + 1;
    let currentYear = new Date().getFullYear();

    this.state = {
      menuLinks: config['menuItems'],
      loading: false,
      modalOpen: false,
      message: '',
      menus: [],
      mainLinks: [],
      links: [],
      icons: [],
      menu,
      store: stores.length > 0 ? stores[0].storeName : '',
      storeid: stores.length > 0 ? stores[0].storeId : '',
      warehouses: warehouses.length > 0 ? warehouses[0].storeName : '',
      warehouseid: warehouses.length > 0 ? warehouses[0].storeId : '',
      currentMonth,
      currentYear,
    };
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
      message: '',
    });
  };

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'js/tabs.js';
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    const {
      modalOpen,
      storeid,
      store,
      currentMonth,
      currentYear,
      warehouses,
      warehouseid,
    } = this.state;

    return (
      <>
        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        <aside className='main-sidebar'>
          <section className='sidebar'>
            <ul className='sidebar-menu' data-widget='tree'>
              <li className='header'>MAIN NAVIGATION</li>
              {this.state.menu.map((val, index) =>
                val.value == 1 ? (
                  val.featureAccess ? (
                    <li
                      className={`treeview`} //active menu-open
                      data-widget='tree'
                      key={val + index}
                    >
                      {/* <li
                      className={`treeview`} //active menu-open
                      data-widget="tree"
                      key={val + index}
                    > */}
                      <Link to={'/'}>
                        <i
                          className={this.state.menuLinks[val.featureName].icon}
                        ></i>
                        <span>{val.featureName}</span>
                        <span className='pull-right-container'>
                          <i className='fa fa-angle-down pull-right'></i>
                        </span>
                      </Link>
                      <ul className='treeview-menu' data-widget='tree'>
                        {val.featureAccess
                          ? val.featureAccess.map((child1, ind) =>
                              child1.value == 1 ? (
                                val.featureName === 'Dashboard' ? (
                                  <li key={child1 + ind}>
                                    {/* <Link
                                      to={{
                                        pathname: this.state.menuLinks[
                                          child1.featureName
                                        ].path,
                                        state: {
                                          tabIndex: 0,
                                          //storeName: store,
                                          //storeId: storeid,
                                          month: currentMonth,
                                          year: currentYear,
                                          //warehouseName: warehouses,
                                          //warehouseid: warehouseid,
                                        },
                                      }}
                                    > */}
                                    <Link to={{pathname: this.state.menuLinks[
                                          child1.featureName
                                        ].path}} state={{ 
                                          tabIndex: 0,
                                          //storeName: store,
                                          //storeId: storeid,
                                          month: currentMonth,
                                          year: currentYear,
                                          //warehouseName: warehouses,
                                          //warehouseid: warehouseid,
                          }} >
                                      <i className='fa fa-caret-right '></i>
                                      {child1.featureName}
                                    </Link>
                                  </li>
                                ) : (
                                  <li key={child1 + ind}>
                                    <Link
                                      to={{
                                        pathname: this.state.menuLinks[
                                          child1.featureName
                                        ].path,
                                      }}
                                    >
                                      <i className='fa fa-caret-right '></i>
                                      {child1.featureName}
                                    </Link>
                                  </li>
                                )
                              ) : null
                            )
                          : null}
                      </ul>
                    </li>
                  ) : (
                    <li
                      key={this.state.menuLinks[val.featureName].path + index}
                    >
                      <Link
                        to={{
                          pathname: this.state.menuLinks[val.featureName].path,
                        }}
                      >
                        <i
                          className={this.state.menuLinks[val.featureName].icon}
                        ></i>{' '}
                        <span>{val.featureName}</span>
                      </Link>
                    </li>
                  )
                ) : null
              )}
            </ul>
          </section>
        </aside>
        
      </>
    );
  }
}

export default Menu;
